import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

function onDialogMainAction(dialogType) {
  trackEvent(events.DIALOG_SUBMITTED, {
    dialogId: dialogType,
  });
}

export default onDialogMainAction;
